import root from 'window-or-global';
import {AlertComponentType} from '../types';

export default function(alert: string, key: AlertComponentType) {
    try {
        root.localStorage.setItem(`${key}-${alert}`, 'true');
    } catch (err) {
        console.error(`Unable to hide alert ${alert}`);
    }
}
